export enum DataLayerErrorType {
    DUNNING_ERROR = 'unpaid bill',
    CANNOT_ORDER_MORE_ERROR = 'cannot order more',
    RESTRICTED_PURCHASE_ERROR = 'restricted purchase',
    GENERIC_ERROR = 'generic error',
    NO_SERVICE_LOCATION_ERROR = 'no service location',
    INFLIGHT_ORDER_ERROR = 'inflight order',
    NOT_AVAILABLE_PARTNER_ERROR = 'not available partner',
    SESSION_EXPIRED_ERROR = 'session expired',
    MULTIPLE_BROADBAND_ERROR = 'multiple broadband',
    NO_ACTIVE_BROADBAND_ERROR = 'no active broadband',
    PRODUCT_NOT_AVAILABLE_ERROR = 'product not available',
}
